(function () {
  // ---- Homepage detector ----
  function isHomepage() {
    try {
      const b = document.body;
      const path = (window.location.pathname || "").replace(/\/+$/, "");
      return (
        b.classList.contains("template-index") ||
        (b.dataset && (b.dataset.template === "index" || b.dataset.page === "index")) ||
        path === "" // homepage
      );
    } catch (e) {
      return false;
    }
  }

  // ---- One-time: ensure the SVG grain filter exists ----
  function ensureGrainFilter() {
    if (document.getElementById("oh-grain")) return; // already present

    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("width", "0");
    svg.setAttribute("height", "0");
    svg.setAttribute("aria-hidden", "true");
    svg.style.position = "absolute";

    const filter = document.createElementNS(svgNS, "filter");
    filter.setAttribute("id", "oh-grain");

    const turb = document.createElementNS(svgNS, "feTurbulence");
    turb.setAttribute("type", "fractalNoise");
    turb.setAttribute("baseFrequency", "0.65");
    turb.setAttribute("numOctaves", "1");
    turb.setAttribute("seed", "9");

    const sat = document.createElementNS(svgNS, "feColorMatrix");
    sat.setAttribute("type", "saturate");
    sat.setAttribute("values", "0");

    const comp = document.createElementNS(svgNS, "feComponentTransfer");
    const funcA = document.createElementNS(svgNS, "feFuncA");
    funcA.setAttribute("type", "table");
    funcA.setAttribute("tableValues", "0 0.035");
    comp.appendChild(funcA);

    filter.appendChild(turb);
    filter.appendChild(sat);
    filter.appendChild(comp);
    svg.appendChild(filter);

    (document.body || document.documentElement).appendChild(svg);
  }

  // ---- Reduce layer churn after each element finishes animating ----
  function settleAfterTransition(el) {
    function done(e) {
      if (e && e.target !== el) return;
      el.style.willChange = "auto";
      el.removeEventListener("transitionend", done);
    }
    el.style.willChange = "opacity, transform";
    el.addEventListener("transitionend", done, { once: true });
  }

  // ---- Early exits (non-homepage, reduced motion, no IO) ----
  function revealAllInstantly() {
    document
      .querySelectorAll("#MainContent .shopify-section")
      .forEach((sec) => sec.classList.add("is-visible"));
  }

  if (!isHomepage()) {
    revealAllInstantly();
    return;
  }

  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    revealAllInstantly();
    return;
  }

  if (!("IntersectionObserver" in window)) {
    revealAllInstantly();
    return;
  }

  // ---- Tunables (tweaked for mobile stability) ----
  const SECTION_STAGGER  = 50;                // was 60 (less overlap)
  const REVEAL_THRESHOLD = 0.25;              // was 0.35 (reveal sooner)
  const ROOT_MARGIN      = "0px 0px -5% 0px"; // was -15% (trigger earlier)

  // --- Luxury inner cascade: Headings → Text → CTA → Images ---
  function cascadeChildren(section) {
    if (section.querySelector(".no-reveal")) return;

    const heads = section.querySelectorAll("h1, h2, h3, [data-heading], .heading, .section-title");
    const text  = section.querySelectorAll("p, .rte p, li, [data-text], .subheading, .lede, .caption");
    const ctas  = section.querySelectorAll("a.button, .button, .btn, button[type], [data-cta]");
    const imgs  = section.querySelectorAll("img, picture, video, .media, .image, .card__media");

    heads.forEach((el) => el.classList.add("reveal-head"));
    text.forEach((el)  => el.classList.add("reveal-text"));
    ctas.forEach((el)  => el.classList.add("reveal-cta"));
    imgs.forEach((el)  => el.classList.add("reveal-image"));

    const isMobile = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;

    const GROUP_GAP  = isMobile ? 110 : 160;
    const STEP_HEAD  = isMobile ?  80 : 100;
    const STEP_TEXT  = isMobile ?  65 :  80;
    const STEP_CTA   = isMobile ?  90 : 110;
    const STEP_IMAGE = isMobile ?  75 :  90;

    let t = 0;
    heads.forEach((el) => { el.style.transitionDelay = `${t}ms`; t += STEP_HEAD; });
    if (heads.length) t += GROUP_GAP;
    text.forEach((el)  => { el.style.transitionDelay = `${t}ms`; t += STEP_TEXT; });
    if (text.length) t += GROUP_GAP;
    ctas.forEach((el)  => { el.style.transitionDelay = `${t}ms`; t += STEP_CTA; });
    if (ctas.length) t += Math.round(GROUP_GAP * 0.6);
    imgs.forEach((el)  => { el.style.transitionDelay = `${t}ms`; t += STEP_IMAGE; });

    // Promote to GPU now; release after first transition completes
    [...heads, ...text, ...ctas, ...imgs].forEach((el) => settleAfterTransition(el));
  }

  // ---- Core setup ----
  function setupReveals(root) {
    ensureGrainFilter(); // ensure #oh-grain exists for optional .use-grain CSS

    const scope = root || document;
    const sections = scope.querySelectorAll("#MainContent .shopify-section");

    // Anything matching this selector is shown instantly (skipped)
    const SKIP_SELECTOR = [
      ":first-of-type",                 // top hero (first section)
      ".slideshow", ".slideshow-hero",  // your custom hero + common slideshow class
      ".banner", ".hero",               // common hero/banner classes
      '[data-section-type="slideshow"]',
      '[data-section-type="banner"]',
      '[data-section-type="hero"]',
      '[data-section-type="slideshow-hero"]'
    ].join(",");

    sections.forEach((sec, i) => {
      // Skip hero/slideshow by selector
      if (sec.matches(SKIP_SELECTOR)) {
        sec.classList.add("is-visible");
        sec.classList.remove("reveal");
        return;
      }

      // Existing opt-out
      if (sec.querySelector(".no-reveal")) {
        sec.classList.remove("reveal");
        sec.classList.add("is-visible");
        return;
      }

      // Prepare once
      if (!sec.classList.contains("reveal")) {
        sec.classList.add("reveal");
        sec.style.transitionDelay = i * SECTION_STAGGER + "ms";
        cascadeChildren(sec);
      }
    });

    // Observe only revealable sections
    const els = scope.querySelectorAll("#MainContent .shopify-section.reveal");
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= REVEAL_THRESHOLD) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target); // fire once
          }
        });
      },
      {
        root: null,
        rootMargin: ROOT_MARGIN,
        threshold: [0, 0.1, 0.25, 0.35, 0.5, 0.75, 1]
      }
    );

    els.forEach((el) => io.observe(el));
  }

  // ---- Hooks ----
  document.addEventListener("DOMContentLoaded", () => setupReveals());
  window.addEventListener("load", () => setupReveals());
  document.addEventListener("shopify:section:load", (e) => setupReveals(e.target));
})();
